import { useLabel } from '@platform/hooks/useLabel';
import { cx } from '@platform/core/lib/cx';
import type { IColorSchemeCardProps } from './IColorSchemeCardProps';

/**
 * Картка схеми як у профілі прототипу v4: мініатюра оболонки кольорами самої схеми (тло, ліве меню, поверхня, лінії, текст,
 * акцент), назва, режим і ✓ на вибраній; рамка 2px акценту поточної схеми.
 */
export function ColorSchemeCard({ scheme, active, modeLabel, onSelect }: IColorSchemeCardProps) {
  const label = useLabel();
  const k = scheme.tokens;
  return (
    <button type="button" className={cx('scheme-card', active && 'is-active')} aria-pressed={active} onClick={() => onSelect(scheme.id)}>
      <span className="scheme-card__preview" style={{ background: k.bg, borderColor: k.line2 }} aria-hidden>
        <span className="scheme-card__side" style={{ background: k.side, borderColor: k.line2 }}>
          <span className="scheme-card__bar" style={{ background: k.accent, width: '70%', height: 5 }} />
          <span className="scheme-card__bar" style={{ background: k.line2 }} />
          <span className="scheme-card__bar" style={{ background: k.line2 }} />
        </span>
        <span className="scheme-card__main">
          <span className="scheme-card__bar" style={{ background: k.ink, width: '55%', height: 6 }} />
          <span className="scheme-card__surface" style={{ background: k.surface, borderColor: k.line2 }} />
          <span className="scheme-card__bar scheme-card__bar--end" style={{ background: k.accent, width: '36%', height: 8 }} />
        </span>
      </span>
      <span className="scheme-card__foot">
        <span className="scheme-card__names">
          <span className="scheme-card__name">{label(scheme.label)}</span>
          <span className="scheme-card__mode">{modeLabel}</span>
        </span>
        {active && <span className="scheme-card__check" aria-hidden>✓</span>}
      </span>
    </button>
  );
}
